import { render, staticRenderFns } from "./ViewTab.vue?vue&type=template&id=6ad037ac"
import script from "./ViewTab.vue?vue&type=script&lang=js"
export * from "./ViewTab.vue?vue&type=script&lang=js"
import style0 from "./ViewTab.vue?vue&type=style&index=0&id=6ad037ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports